import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'

export const ScoutingPageContainer = styled(Container)`
  &&.container-fluid {
    width: 100% !important;
    max-width: 100% !important;
    align-items: stretch !important;
  }

  display: flex;
  padding: 0px 32px !important;
  box-sizing: border-box;
  flex-direction: column;
  align-items: stretch;
  gap: 30px;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 0px 16px !important;
  }
`

export const VisualizationContainer = styled(Container)`
  &&.container-fluid {
    width: 100% !important;
    max-width: 100% !important;
    align-items: stretch !important;
  }

  display: flex;
  padding: 0 !important;
  flex-direction: column;
  align-items: stretch;
  gap: 30px;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`

export const VisualizationLayoutRow = styled(Row)`
  gap: 0;
  width: 100%;
  min-width: 0;
`

export const AboutContentColumn = styled(Col)`
  min-width: 0;
  max-width: 100%;
`

export const SidebarWrapper = styled.div`
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 24px 20px;
`

export const SidebarItem = styled.button<{ isActive: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 4px 0 8px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: ${props => (props.isActive ? 700 : 500)};
  color: ${props => (props.isActive ? '#00599C' : '#4B5563')};
  cursor: pointer;

  border-bottom: ${props => (props.isActive ? '2px solid #00599C' : '2px solid transparent')};

  &:last-child {
    margin-bottom: 0;
  }

  &:focus {
    outline: none;
  }
`
